<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    deleteTitle="Finalização de Safra"
    :formErrors="formErrors"
    deleteConfirmButtonLabel="Finalizar"
    deleteIcon="mdi-check"
    deleteButtonLabel="Finalizar Safra"
    deleteColor="green"
    :alwaysEnabled="true"
    :modelNameSingular="modelNameSingular"
  >
    <p> Você tem certeza que deseja finalizar a safra <b>{{this.entry.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(harvest) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: FINALIZE_HARVEST_MUTATION,
          variables: {
            id: harvest.id,
          }
        })
        .then(response => {
          var errors = response.data.finalizeHarvest.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const FINALIZE_HARVEST_MUTATION = gql `
  mutation($id: ID!) {
    finalizeHarvest(id: $id) {
      harvest {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>